module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"message":"ระบบเกิดการขัดข้อง <br> อีกสักครู่ กรุณาลองอีกครั้งครับ","closeButton":"ปิด"}}')
  delete Component.options._Ctor
}
